/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Category_ProgressInputs */

const en_us2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const pt_br2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const es_419_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

const pt_pt2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const fr_fr2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progrès`)
};

const de_de2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt`)
};

const it_it2_community_category_progress = /** @type {(inputs: Community_Category_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressi`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Community_Category_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_category_progress = /** @type {((inputs?: Community_Category_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Category_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_category_progress(inputs)
	if (locale === "es-419") return es_419_community_category_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_community_category_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_community_category_progress(inputs)
	if (locale === "de-DE") return de_de2_community_category_progress(inputs)
	if (locale === "it-IT") return it_it2_community_category_progress(inputs)
	return en_us2_community_category_progress(inputs)
});
export { community_category_progress as "community.category_progress" }